import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/lucide-react@1.46.0_react@19.3.0/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.4.2_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.5.1_babel-plugin_e555e45d7cd24a1277f97b608695002e/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/shared/content/code/LazyCodeBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/vercel/path0/src/hub/components/mdx/code.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaBanner"] */ "/vercel/path0/src/hub/components/mdx/cta-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaButton"] */ "/vercel/path0/src/hub/components/mdx/cta-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Img"] */ "/vercel/path0/src/hub/components/mdx/img.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InstallOpenTelemetryDemoButton"] */ "/vercel/path0/src/hub/components/mdx/install-otel-demo-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Video"] */ "/vercel/path0/src/hub/components/mdx/video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IntegrationDetailPageImpl"] */ "/vercel/path0/src/hub/pages/integration-detail-page/integration-detail-page-impl.tsx");
